import { ProjectCreateRouteView } from './view';
import { withCrumb } from '@/app/routing/breadcrumbs';

export const createRoute = {
  path: 'create',
  element: <ProjectCreateRouteView/>,
  handle: () => withCrumb({
    element: () => <span>Create</span>,
  }),
};